import styled from 'styled-components';
import { TextField } from '@material-ui/core';
import { devices } from '../../util/device';

export const Input = styled( TextField )`
  width: 100%;
  margin-right: 16px;

  @media ${devices.mobileL} {
    width: 40%;
  }
`;
